import React, { useState} from 'react';
import Alert from './Alert';
import AttachMoneyIcon from '@mui/icons-material/AttachMoney';
function TransferAsset(props) {
    const[assetId,setAssetId]=useState("");
    const [receiverAddress, setReceiverAddress] = useState("");
    const [lastPrice,setlastPrice]=useState("");
    let value;
    const handleAssetId=(e)=>{
        value=e.target.value;
        setAssetId(value);
    }
    const handleAdr=(e)=>{
        value=e.target.value;
        setReceiverAddress(value);
    }
    const handlelastPrice=(e)=>{
        value=e.target.value;
        setlastPrice(value);
    }
    let sender,id,last;
    const transferAsset= async(e)=>{
        e.preventDefault();
        props.setProgress(10);
        const accounts = await window.ethereum.enable();
        const account = accounts[0];
        sender=receiverAddress;
        id=assetId;
        last=parseInt(lastPrice)
        setAssetId("");
        setReceiverAddress("");
        setlastPrice("");
        console.log(last);
        props.setProgress(100);
        try{
            const result=await props.SimpleContract.methods.transferAsset(sender,id,last).send({
                from: account
            });
          }
          catch(err){
            console.log(err);
          }
    }
    const isMetaMaskInstall=()=>{
        if(props.SimpleContract===undefined){
            const  obj={
                type:"warning",
                message:"Please Install MetaMask and Refresh the Page."
            }
            return(
                <Alert alert={obj}/>
            )
        }
    }
    return (
        <>
        {isMetaMaskInstall()}
        <div className="forcenter">
        <div className="fordetail">
            <form className="container mt-4">
                <div className="form-floating mb-4">
                    <input type="text" className="form-control" id="_assetId" name="_assetId" value={assetId}  placeholder="assetId" onChange={handleAssetId}/>
                    <label htmlFor="floatingInput">Asset Id</label>
                </div>
                <div className="form-floating mb-4">
                    <input type="text" className="form-control" id="receiverAddress" name="receiverAddress" value={receiverAddress}  placeholder="newDetail" onChange={handleAdr}/>
                    <label htmlFor="floatingInput">Reciever address</label>
                </div>
                <div className="form-floating mb-5">
                    <input type="text" className="form-control" id="lastPrice" name="lastPrice" value={lastPrice}  placeholder="newDetail" onChange={handlelastPrice}/>
                    <label htmlFor="floatingInput"><AttachMoneyIcon/>Asset price</label>
                </div>
                <button type="submit" className="btn btn-primary" disabled={!(assetId!=="" && receiverAddress!=="" && lastPrice!=="")}  onClick={transferAsset}>Transfer</button>
            </form> 
            </div>
            </div>
        </>
    )
}

export default TransferAsset
